// extracted by mini-css-extract-plugin
module.exports = {"projectBoundriesWrapper":"projectBoundries_projectBoundriesWrapper__hDTik"};